import {Result, Spin} from "antd";

export default function Loading(props: any) {
    return (
        <Result
            icon={<Spin spinning={true}/>}
            title="Loading..."
        />
    )
}